/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { EnforcementConfigPaginatedResponse } from '../model/enforcementConfigPaginatedResponse';
// @ts-ignore
import { EnforcementConfigPatchSpec } from '../model/enforcementConfigPatchSpec';
// @ts-ignore
import { EnforcementConfigPostSpec } from '../model/enforcementConfigPostSpec';
// @ts-ignore
import { EnforcementConfigRecord } from '../model/enforcementConfigRecord';
// @ts-ignore
import { EnforcementConfigResponse } from '../model/enforcementConfigResponse';
// @ts-ignore
import { EnforcementHistoryPaginatedResponse } from '../model/enforcementHistoryPaginatedResponse';
// @ts-ignore
import { EnforcementHistoryRecord } from '../model/enforcementHistoryRecord';
// @ts-ignore
import { EnforcementSignalPaginatedResponse } from '../model/enforcementSignalPaginatedResponse';
// @ts-ignore
import { EnforcementSignalPatchSpec } from '../model/enforcementSignalPatchSpec';
// @ts-ignore
import { EnforcementSignalPostSpec } from '../model/enforcementSignalPostSpec';
// @ts-ignore
import { EnforcementSignalRecord } from '../model/enforcementSignalRecord';
// @ts-ignore
import { EnforcementSignalResponse } from '../model/enforcementSignalResponse';
// @ts-ignore
import { EnforcementStatusPaginatedResponse } from '../model/enforcementStatusPaginatedResponse';
// @ts-ignore
import { EnforcementStatusPatchSpec } from '../model/enforcementStatusPatchSpec';
// @ts-ignore
import { EnforcementStatusPostSpec } from '../model/enforcementStatusPostSpec';
// @ts-ignore
import { EnforcementStatusRecord } from '../model/enforcementStatusRecord';
// @ts-ignore
import { EnforcementStatusResponse } from '../model/enforcementStatusResponse';
// @ts-ignore
import { OrgIdsListRequestSpec } from '../model/orgIdsListRequestSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class BillingEnforcementOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete an org overage config record
     * Delete entries in the enforcement_config table
     * @param configState Enforcement Config State
     * @param enforcementCategory Enforcement Config Category
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEnforcementConfig(configState: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementConfigRecord>;
    public deleteEnforcementConfig(configState: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementConfigRecord>>;
    public deleteEnforcementConfig(configState: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementConfigRecord>>;
    public deleteEnforcementConfig(configState: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (configState === null || configState === undefined) {
            throw new Error('Required parameter configState was null or undefined when calling deleteEnforcementConfig.');
        }
        if (enforcementCategory === null || enforcementCategory === undefined) {
            throw new Error('Required parameter enforcementCategory was null or undefined when calling deleteEnforcementConfig.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling deleteEnforcementConfig.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configState, 'config-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>enforcementCategory, 'enforcement-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-config`;
        return this.httpClient.request<EnforcementConfigRecord>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete an enforcement history record
     * Delete entries in the enforcement_history table
     * @param historyQueryIdRequired Enforcement history Id Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEnforcementHistory(historyQueryIdRequired: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementHistoryRecord>;
    public deleteEnforcementHistory(historyQueryIdRequired: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementHistoryRecord>>;
    public deleteEnforcementHistory(historyQueryIdRequired: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementHistoryRecord>>;
    public deleteEnforcementHistory(historyQueryIdRequired: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (historyQueryIdRequired === null || historyQueryIdRequired === undefined) {
            throw new Error('Required parameter historyQueryIdRequired was null or undefined when calling deleteEnforcementHistory.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>historyQueryIdRequired, 'history-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-history`;
        return this.httpClient.request<EnforcementHistoryRecord>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete an enforcement signal record
     * Delete entries in the enforcement_signal table
     * @param signalQueryIdRequired Enforcement signal Id Primary Key
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEnforcementSignal(signalQueryIdRequired: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementSignalRecord>;
    public deleteEnforcementSignal(signalQueryIdRequired: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementSignalRecord>>;
    public deleteEnforcementSignal(signalQueryIdRequired: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementSignalRecord>>;
    public deleteEnforcementSignal(signalQueryIdRequired: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (signalQueryIdRequired === null || signalQueryIdRequired === undefined) {
            throw new Error('Required parameter signalQueryIdRequired was null or undefined when calling deleteEnforcementSignal.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>signalQueryIdRequired, 'signal-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-signal`;
        return this.httpClient.request<EnforcementSignalRecord>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete an org overage status record
     * Delete entries in the enforcement_status table
     * @param orgId organization identifier
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEnforcementStatus(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementStatusRecord>;
    public deleteEnforcementStatus(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementStatusRecord>>;
    public deleteEnforcementStatus(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementStatusRecord>>;
    public deleteEnforcementStatus(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling deleteEnforcementStatus.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling deleteEnforcementStatus.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-status`;
        return this.httpClient.request<EnforcementStatusRecord>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get org overage enforcement config records based on filters
     * Get entries from the enforcement_config table based on filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the enforcement config by this column
     * @param serviceType Service Type
     * @param exitDays Enforcement Config Exit days
     * @param configState Enforcement Config State
     * @param enforcementCategory Enforcement Config Category
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnforcementConfig(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'exitDays' | 'state' | 'enforcementCategory' | 'serviceType', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', exitDays?: number, configState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementConfigPaginatedResponse>;
    public getEnforcementConfig(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'exitDays' | 'state' | 'enforcementCategory' | 'serviceType', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', exitDays?: number, configState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementConfigPaginatedResponse>>;
    public getEnforcementConfig(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'exitDays' | 'state' | 'enforcementCategory' | 'serviceType', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', exitDays?: number, configState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementConfigPaginatedResponse>>;
    public getEnforcementConfig(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'exitDays' | 'state' | 'enforcementCategory' | 'serviceType', serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', exitDays?: number, configState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', enforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getEnforcementConfig.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getEnforcementConfig.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>exitDays, 'exit-days');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>configState, 'config-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>enforcementCategory, 'enforcement-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-config`;
        return this.httpClient.request<EnforcementConfigPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get org overage enforcement history records based on filters
     * Get entries from the enforcement_history table based on filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the enforcement history by this column
     * @param orgId ORG identifier
     * @param serviceType Service Type
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param userId Enforcement history user Id.
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnforcementHistory(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', startTime?: string, endTime?: string, userId?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementHistoryPaginatedResponse>;
    public getEnforcementHistory(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', startTime?: string, endTime?: string, userId?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementHistoryPaginatedResponse>>;
    public getEnforcementHistory(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', startTime?: string, endTime?: string, userId?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementHistoryPaginatedResponse>>;
    public getEnforcementHistory(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', startTime?: string, endTime?: string, userId?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getEnforcementHistory.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getEnforcementHistory.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>userId, 'userId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-history`;
        return this.httpClient.request<EnforcementHistoryPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get org overage enforcement signal records based on filters
     * Get entries from the enforcement_signal table based on filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the enforcement signal by this column
     * @param orgId ORG identifier
     * @param serviceType Service Type
     * @param vcdsServiceType VCDS Service Type
     * @param enforcementState Enforcement signal states
     * @param status Enforcement signal status by this column
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnforcementSignal(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'stateEnteredTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', enforcementState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', status?: 'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementSignalPaginatedResponse>;
    public getEnforcementSignal(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'stateEnteredTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', enforcementState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', status?: 'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementSignalPaginatedResponse>>;
    public getEnforcementSignal(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'stateEnteredTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', enforcementState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', status?: 'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementSignalPaginatedResponse>>;
    public getEnforcementSignal(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'stateEnteredTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', enforcementState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', status?: 'QUEUED' | 'IN_PROGRESS' | 'DONE' | 'FAILED' | 'CANCELING' | 'CANCELED', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getEnforcementSignal.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getEnforcementSignal.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>enforcementState, 'enforcement-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>status, 'status');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-signal`;
        return this.httpClient.request<EnforcementSignalPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get org overage enforcement status records based on filters
     * Get entries from the enforcement_status table based on filters
     * @param sortByOrder Sort the properties by this order
     * @param sortBy Sort the enforcement status by this column
     * @param orgId ORG identifier
     * @param serviceType Service Type
     * @param currentState Enforcement Status current state
     * @param scheduledNextState Enforcement Status scheduled next state
     * @param scheduledNextEnforcementCategory Enforcement Status scheduled next Enforcement Category
     * @param startTime Time at which query starts
     * @param endTime Time at which query ends
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnforcementStatus(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'pauseEndTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', currentState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextEnforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementStatusPaginatedResponse>;
    public getEnforcementStatus(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'pauseEndTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', currentState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextEnforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementStatusPaginatedResponse>>;
    public getEnforcementStatus(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'pauseEndTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', currentState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextEnforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementStatusPaginatedResponse>>;
    public getEnforcementStatus(sortByOrder: 'ASC' | 'DESC', sortBy: 'createdTs' | 'updatedTs' | 'nextActionTs' | 'pauseEndTs', orgId?: string, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', currentState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextState?: 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED', scheduledNextEnforcementCategory?: 'NON_SUBSCRIPTION' | 'OVERAGE' | 'NONE', startTime?: string, endTime?: string, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sortByOrder === null || sortByOrder === undefined) {
            throw new Error('Required parameter sortByOrder was null or undefined when calling getEnforcementStatus.');
        }
        if (sortBy === null || sortBy === undefined) {
            throw new Error('Required parameter sortBy was null or undefined when calling getEnforcementStatus.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>currentState, 'current-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>scheduledNextState, 'scheduled-next-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>scheduledNextEnforcementCategory, 'scheduled-next-enforcement-category');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>startTime, 'start-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endTime, 'end-time');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-status`;
        return this.httpClient.request<EnforcementStatusPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Pause enforcement or extend action date.
     * Pause the enforcement calculation or extend the next action date for state transition
     * @param orgId organization identifier
     * @param serviceType Service Type
     * @param isEnforcementPaused is enforcement paused
     * @param pauseUntilDate Pause until date
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pauseOrExtendActionDateOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', isEnforcementPaused: boolean, pauseUntilDate: Date, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public pauseOrExtendActionDateOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', isEnforcementPaused: boolean, pauseUntilDate: Date, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public pauseOrExtendActionDateOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', isEnforcementPaused: boolean, pauseUntilDate: Date, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public pauseOrExtendActionDateOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', isEnforcementPaused: boolean, pauseUntilDate: Date, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling pauseOrExtendActionDateOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling pauseOrExtendActionDateOperator.');
        }
        if (isEnforcementPaused === null || isEnforcementPaused === undefined) {
            throw new Error('Required parameter isEnforcementPaused was null or undefined when calling pauseOrExtendActionDateOperator.');
        }
        if (pauseUntilDate === null || pauseUntilDate === undefined) {
            throw new Error('Required parameter pauseUntilDate was null or undefined when calling pauseOrExtendActionDateOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>isEnforcementPaused, 'is-enforcement-paused');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pauseUntilDate, 'pause-until-date');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/enforcement/pause-or-extend-action-date`;
        return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an enforcement config for an org.
     * Post an enforcement config for an org
     * @param enforcementConfigPostSpec Spec to post an enforcement config for an org
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEnforcementConfig(enforcementConfigPostSpec: Array<EnforcementConfigPostSpec>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementConfigResponse>;
    public postEnforcementConfig(enforcementConfigPostSpec: Array<EnforcementConfigPostSpec>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementConfigResponse>>;
    public postEnforcementConfig(enforcementConfigPostSpec: Array<EnforcementConfigPostSpec>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementConfigResponse>>;
    public postEnforcementConfig(enforcementConfigPostSpec: Array<EnforcementConfigPostSpec>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (enforcementConfigPostSpec === null || enforcementConfigPostSpec === undefined) {
            throw new Error('Required parameter enforcementConfigPostSpec was null or undefined when calling postEnforcementConfig.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-config`;
        return this.httpClient.request<EnforcementConfigResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enforcementConfigPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an enforcement signal for an org.
     * Post an enforcement signal for an org
     * @param enforcementSignalPostSpec Spec to post an enforcement signal for an org
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEnforcementSignal(enforcementSignalPostSpec: Array<EnforcementSignalPostSpec>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementSignalResponse>;
    public postEnforcementSignal(enforcementSignalPostSpec: Array<EnforcementSignalPostSpec>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementSignalResponse>>;
    public postEnforcementSignal(enforcementSignalPostSpec: Array<EnforcementSignalPostSpec>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementSignalResponse>>;
    public postEnforcementSignal(enforcementSignalPostSpec: Array<EnforcementSignalPostSpec>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (enforcementSignalPostSpec === null || enforcementSignalPostSpec === undefined) {
            throw new Error('Required parameter enforcementSignalPostSpec was null or undefined when calling postEnforcementSignal.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-signal`;
        return this.httpClient.request<EnforcementSignalResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enforcementSignalPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create an enforcement status for an org.
     * Post an enforcement status for an org
     * @param enforcementStatusPostSpec Spec to post an enforcement status for an org
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postEnforcementStatus(enforcementStatusPostSpec: Array<EnforcementStatusPostSpec>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementStatusResponse>;
    public postEnforcementStatus(enforcementStatusPostSpec: Array<EnforcementStatusPostSpec>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementStatusResponse>>;
    public postEnforcementStatus(enforcementStatusPostSpec: Array<EnforcementStatusPostSpec>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementStatusResponse>>;
    public postEnforcementStatus(enforcementStatusPostSpec: Array<EnforcementStatusPostSpec>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (enforcementStatusPostSpec === null || enforcementStatusPostSpec === undefined) {
            throw new Error('Required parameter enforcementStatusPostSpec was null or undefined when calling postEnforcementStatus.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-status`;
        return this.httpClient.request<EnforcementStatusResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enforcementStatusPostSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Resume enforcement.
     * Resume the enforcement calculation
     * @param orgId organization identifier
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resumeEnforcementOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public resumeEnforcementOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public resumeEnforcementOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public resumeEnforcementOperator(orgId: string, serviceType: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling resumeEnforcementOperator.');
        }
        if (serviceType === null || serviceType === undefined) {
            throw new Error('Required parameter serviceType was null or undefined when calling resumeEnforcementOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/enforcement/resume`;
        return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Trigger and refresh billing overage enforcement.
     * Trigger and refresh billing overage enforcement.
     * @param orgIdsListRequestSpec Optional org ids list spec
     * @param effectiveNowTs Effective now timestamp
     * @param serviceType Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public runEnforcementProcess(orgIdsListRequestSpec: OrgIdsListRequestSpec, effectiveNowTs?: Date, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public runEnforcementProcess(orgIdsListRequestSpec: OrgIdsListRequestSpec, effectiveNowTs?: Date, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public runEnforcementProcess(orgIdsListRequestSpec: OrgIdsListRequestSpec, effectiveNowTs?: Date, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public runEnforcementProcess(orgIdsListRequestSpec: OrgIdsListRequestSpec, effectiveNowTs?: Date, serviceType?: 'VCDR' | 'VMCFS' | 'VMUA', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgIdsListRequestSpec === null || orgIdsListRequestSpec === undefined) {
            throw new Error('Required parameter orgIdsListRequestSpec was null or undefined when calling runEnforcementProcess.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>effectiveNowTs, 'effective-now-ts');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>serviceType, 'service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/run-enforcement-process`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: orgIdsListRequestSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an org overage config
     * Update an entry in the enforcement_config table
     * @param enforcementConfigPatchSpec Spec to update the org overage config record
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEnforcementConfig(enforcementConfigPatchSpec: EnforcementConfigPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementConfigRecord>;
    public updateEnforcementConfig(enforcementConfigPatchSpec: EnforcementConfigPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementConfigRecord>>;
    public updateEnforcementConfig(enforcementConfigPatchSpec: EnforcementConfigPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementConfigRecord>>;
    public updateEnforcementConfig(enforcementConfigPatchSpec: EnforcementConfigPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (enforcementConfigPatchSpec === null || enforcementConfigPatchSpec === undefined) {
            throw new Error('Required parameter enforcementConfigPatchSpec was null or undefined when calling updateEnforcementConfig.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-config`;
        return this.httpClient.request<EnforcementConfigRecord>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enforcementConfigPatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an org overage record
     * Update an entry in the enforcement_signal table
     * @param signalQueryIdRequired Enforcement signal Id Primary Key
     * @param enforcementSignalPatchSpec Spec to update the org overage record with
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEnforcementSignal(signalQueryIdRequired: number, enforcementSignalPatchSpec: EnforcementSignalPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementSignalRecord>;
    public updateEnforcementSignal(signalQueryIdRequired: number, enforcementSignalPatchSpec: EnforcementSignalPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementSignalRecord>>;
    public updateEnforcementSignal(signalQueryIdRequired: number, enforcementSignalPatchSpec: EnforcementSignalPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementSignalRecord>>;
    public updateEnforcementSignal(signalQueryIdRequired: number, enforcementSignalPatchSpec: EnforcementSignalPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (signalQueryIdRequired === null || signalQueryIdRequired === undefined) {
            throw new Error('Required parameter signalQueryIdRequired was null or undefined when calling updateEnforcementSignal.');
        }
        if (enforcementSignalPatchSpec === null || enforcementSignalPatchSpec === undefined) {
            throw new Error('Required parameter enforcementSignalPatchSpec was null or undefined when calling updateEnforcementSignal.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>signalQueryIdRequired, 'signal-query-id-required');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-signal`;
        return this.httpClient.request<EnforcementSignalRecord>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enforcementSignalPatchSpec,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an org overage status
     * Update an entry in the enforcement_status table
     * @param enforcementStatusPatchSpec Spec to update the org overage status record
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateEnforcementStatus(enforcementStatusPatchSpec: EnforcementStatusPatchSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<EnforcementStatusRecord>;
    public updateEnforcementStatus(enforcementStatusPatchSpec: EnforcementStatusPatchSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EnforcementStatusRecord>>;
    public updateEnforcementStatus(enforcementStatusPatchSpec: EnforcementStatusPatchSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EnforcementStatusRecord>>;
    public updateEnforcementStatus(enforcementStatusPatchSpec: EnforcementStatusPatchSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (enforcementStatusPatchSpec === null || enforcementStatusPatchSpec === undefined) {
            throw new Error('Required parameter enforcementStatusPatchSpec was null or undefined when calling updateEnforcementStatus.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/billing/org-enforcement-status`;
        return this.httpClient.request<EnforcementStatusRecord>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: enforcementStatusPatchSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
